interface OneDriveIconProps {
    className?: string
}

export function OneDriveIcon({ className = 'w-4 h-4' }: OneDriveIconProps) {
    return (
        <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.21 11.8l4.36-2.54 2.32 1.3A5.12 5.12 0 0 1 19.5 9.5a5.1 5.1 0 0 1 1.5.22A7.5 7.5 0 0 0 7.5 6a7.47 7.47 0 0 0-4.35 1.39L9.21 11.8z" fill="#0364B8" />
            <path d="M9.21 11.8L3.15 7.39A6 6 0 0 0 1 11.87a6 6 0 0 0 3.07 5.26l5.14-2.99L9.21 11.8z" fill="#0078D4" />
            <path d="M15.89 10.56l-2.32-1.3-4.36 2.54-.01 2.34-5.13 2.99A6 6 0 0 0 7 18h8.5a5.12 5.12 0 0 0 3.61-1.49l-3.22-5.95z" fill="#1490DF" />
            <path d="M19.5 9.5a5.1 5.1 0 0 0-3.61 1.06l3.22 5.95A5.12 5.12 0 0 0 24 12.5a5 5 0 0 0-4.5-3z" fill="#28A8EA" />
        </svg>
    )
}
